<template>
  <auth-content> </auth-content>
</template>
<script>
import AuthContent from "./AuthContent.vue";
import "@/assets/auth.css";
export default {
  components: {
    AuthContent,
  },
};
</script>
